module.exports = __webpack_public_path__ + "static/media/wrong_choice.75a0526f.svg";